import {ReactNode, useCallback, useEffect, useState} from "react";
import {messaging, getToken} from "./../firebase/firebase";
import {FirebaseContext} from "../contexts/FirebaseContext";
import {onMessage} from "firebase/messaging";
import firebase from "firebase/compat/app";
import MessagePayload = firebase.messaging.MessagePayload;


interface IProps {
    children: ReactNode;
}


const FirebaseProvider = ({children}: IProps) => {
    const [token, setToken] = useState<string | undefined>();

    const handleFcmMessage = useCallback(async (payload: MessagePayload) => {
        console.log(payload);
    }, []);

    useEffect(() => {
        Notification.requestPermission().then(async (permission) => {
            console.log(permission);
            const fcmToken = await getToken(messaging, {vapidKey: "BHGn6Nq6guQDMVantAvtyJm5OEaGTRXHabKOIkISkXjqUvZ28_7xh1LFAbdFJXIGUhHVcR-bdsPLW5Tw9bNaNf0"});
            console.log(fcmToken);
            setToken(fcmToken);
        });
        // const getFCMToken = async () => {
        // }
        // getFCMToken();
        const unsubscribe = onMessage(messaging, handleFcmMessage);
        return () => {
            unsubscribe();
        }
    }, [handleFcmMessage]);

    return (
        <FirebaseContext.Provider value={{token}}>
            {children}
        </FirebaseContext.Provider>
    );
};

export default FirebaseProvider;